import React, { useState, useEffect } from 'react';
import { RevoltModal } from '../../../../../components/RevoltModal';
import { RevoltInput } from '../../../../../components/RevoltInput';
import { RevoltButton } from '../../../../../components/RevoltButton';
import './ProductAccessTagsModal.css';

export function ProductAccessTagsModal({
  isOpen,
  onClose,
  currentTags = [],
  onUpdateTags
}) {
  const [tags, setTags] = useState([...currentTags]);
  const [newTag, setNewTag] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reset modal state when opened
  useEffect(() => {
    if (isOpen) {
      setTags([...currentTags]);
      setNewTag('');
      setIsSubmitting(false);
    }
  }, [isOpen, currentTags]);

  const handleAddTag = () => {
    const tagValue = newTag.trim().toLowerCase();
    if (tagValue && !tags.includes(tagValue)) {
      setTags([...tags, tagValue]);
      setNewTag('');
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  const handleTagKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    try {
      await onUpdateTags(tags);
      onClose();
    } catch (error) {
      console.error('Failed to update access tags:', error);
      alert('Failed to update access tags. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Access Tags"
    >
      <div className="product-access-tags-modal">
        {/* Current Tags Section */}
        <div className="modal-section">
          <label className="modal-label">Current Access Tags</label>
          {tags.length > 0 ? (
            <div className="tags-list">
              {tags.map((tag, index) => (
                <span key={index} className="tag-item">
                  {tag}
                  <button
                    type="button"
                    className="tag-remove"
                    onClick={() => handleRemoveTag(tag)}
                    aria-label={`Remove ${tag} access tag`}
                  >
                    <i className="fa-solid fa-times"></i>
                  </button>
                </span>
              ))}
            </div>
          ) : (
            <p className="no-tags">No access tags yet</p>
          )}
        </div>

        {/* Add New Tag Section */}
        <div className="modal-section">
          <label className="modal-label">Add New Access Tag</label>
          <div className="add-tag-group">
            <RevoltInput
              type="text"
              value={newTag}
              onChange={(e) => setNewTag(e.target.value.replace(/\s+/g, '-'))}
              onKeyPress={handleTagKeyPress}
              placeholder="Enter access tag name..."
              maxLength={50}
            />
            <RevoltButton
              type="button"
              variant="outline"
              size="small"
              onClick={handleAddTag}
              disabled={!newTag.trim() || tags.includes(newTag.trim().toLowerCase())}
            >
              <i className="fa-solid fa-plus"></i>
              Add
            </RevoltButton>
          </div>
          <div className="form-help">
            These tags are added to user accounts when they purchase this product. Use for product bundles/packages.
          </div>
        </div>

        {/* Modal Actions */}
        <div className="modal-actions">
          <RevoltButton
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                Updating...
              </>
            ) : (
              'Update Access Tags'
            )}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}
